import NewJobPost from "@/containers/Company/components/JobPost/NewJobPost";
import Notice from "@/containers/Company/components/Notice/Notice";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { decryption } from "../../../HelperFunctions";
import JobPost from "@/containers/Company/components/JobPost/JobPost";
import JobDetails from "@/containers/Company/components/JobPost/JobDetails";

export default () => {
  const permission = JSON.parse(localStorage?.getItem("permissions"));

  return (
    <Switch>
      <Route
        path="/job_post/list"
        render={() =>
          decryption(permission)?.includes("view_department") ? (
            <JobPost></JobPost>
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/job_post/new"
        render={() =>
          decryption(permission)?.includes("view_department") ? (
            <NewJobPost></NewJobPost>
          ) : (
            <Redirect to="/404" />
          )
        }
      />
      <Route
        path="/job_post/details"
        render={() =>
          decryption(permission)?.includes("view_department") ? (
            <JobDetails></JobDetails>
          ) : (
            <Redirect to="/404" />
          )
        }
      />
    </Switch>
  );
};
